import addDays from "date-fns/addDays"

export default days => addDays(new Date(), -parseInt(days - 1, 10))
